<div class="content" fxLayout="row">
  <div class="inspection-folders-list" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <h3 class="title">{{ "saveIplexDeviceImagesComponent.inspectionFoldersArea" | translate }}</h3>
    </div>
    <ng-container *ngIf="nestedDataSource?.data?.length >= 1">
      <mat-tree [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl" class="tree-content">
        <mat-tree-node *matTreeNodeDef="let folder" matTreeNodeToggle>
          <li
            fxFlex
            fxLayout="row"
            class="mat-tree-node folder-node selectable"
            [class.selected]="folder.fileStat.basename === selectedFolder?.basename"
            (click)="selectFolder(folder); $event.stopPropagation()"
          >
            <div>
              <mat-icon class="folder-icon">folder</mat-icon>
            </div>
            <span class="folder-label" [matTooltip]="folder.fileStat.basename" matTooltipPosition="above" matTooltipClass="tooltip-overflow">
              {{ folder.fileStat.basename }}
            </span>
          </li>
        </mat-tree-node>

        <mat-nested-tree-node *matTreeNodeDef="let folder; when: hasNestedChild">
          <li (click)="selectFolder(folder); $event.stopPropagation()">
            <div class="mat-tree-node selectable" [class.selected]="folder.fileStat.basename === selectedFolder?.basename">
              <button
                class="expand-btn"
                [style.visibility]="folder?.hasChildren ? 'visible' : 'hidden'"
                mat-icon-button
                matTreeNodeToggle
                [attr.aria-label]="'toggle ' + folder.fileStat.basename"
              >
                <mat-icon class="mat-icon-rtl-mirror">
                  {{ nestedTreeControl.isExpanded(folder) ? "expand_more" : "chevron_right" }}
                </mat-icon>
              </button>
              <span class="folder-label" [matTooltip]="folder.fileStat.basename" matTooltipPosition="above" matTooltipClass="tooltip-overflow">
                {{ folder.fileStat.basename }}
              </span>
            </div>
            <ul [class.tree-invisible]="!nestedTreeControl.isExpanded(folder)">
              <ng-container matTreeNodeOutlet></ng-container>
            </ul>
          </li>
        </mat-nested-tree-node>
      </mat-tree>
    </ng-container>
    <ng-container *ngIf="!nestedDataSource || nestedDataSource.data?.length < 1">
      <div class="no-data-labe">
        <h3 class="title">{{ "saveIplexDeviceImagesComponent.noFolders" | translate }}</h3>
      </div>
    </ng-container>
  </div>

  <div fxFlex class="folder-images-list" fxLayout="row wrap">
    <div class="panel images-panel">
      <div class="panel-menu" fxLayout="row" fxLayoutAlign="space-between center">
        <div
          *ngIf="selectedFolder"
          class="title subject-cad-name"
          [matTooltip]="selectedFolder?.basename"
          matTooltipPosition="above"
          matTooltipClass="tooltip-overflow"
        >
          <h3>
            {{ "saveIplexDeviceImagesComponent.folderImagesArea" | translate: { selectedFolder: selectedFolder?.basename } }}
          </h3>
        </div>

        <div *ngIf="!selectedFolder" class="title subject-cad-name">
          <h3>
            {{ "saveIplexDeviceImagesComponent.files" | translate }}
          </h3>
        </div>
      </div>

      <div class="display-container-header">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="selectAll()"
          [indeterminate]="isIndeterminateImageAll()"
          [checked]="isSelectedImageAll()"
          [disabled]="!imageFiles || imageFiles.length < 1"
          >{{ "saveIplexDeviceImagesComponent.all" | translate }}</mat-checkbox
        >
      </div>

      <div class="panel-content">
        <ng-container *ngIf="imageFiles.length >= 1">
          <div class="display-container">
            <table mat-table [dataSource]="imageFiles" class="fileStat-table">
              <!-- CheckBox Column -->
              <ng-container matColumnDef="checkbox">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let wrap">
                  <mat-checkbox [(ngModel)]="wrap.isSelected" fxLayout="row wrap"></mat-checkbox>
                </td>
              </ng-container>

              <!-- Filename Column -->
              <ng-container matColumnDef="filename">
                <th mat-header-cell *matHeaderCellDef>File Name</th>
                <td mat-cell *matCellDef="let wrap" matTooltipClass="tooltip-overflow" matTooltipPosition="above" [matTooltip]="wrap.displayName">
                  {{ wrap.displayName }}
                </td>
              </ng-container>

              <!-- Date Column -->
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Last Modified Date</th>
                <td
                  mat-cell
                  *matCellDef="let wrap"
                  matTooltipClass="tooltip-overflow"
                  matTooltipPosition="above"
                  [matTooltip]="wrap.date | date: dateFormat"
                >
                  {{ wrap.date | date: dateFormat }}
                </td>
              </ng-container>

              <!-- Size Column -->
              <ng-container matColumnDef="size">
                <th mat-header-cell *matHeaderCellDef>Size</th>
                <td
                  mat-cell
                  *matCellDef="let wrap"
                  matTooltipClass="tooltip-overflow"
                  matTooltipPosition="above"
                  [matTooltip]="wrap.fileStat.size | fileSize"
                >
                  {{ wrap.fileStat.size | fileSize }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
        </ng-container>
        <ng-container *ngIf="!imageFiles || imageFiles.length < 1">
          <div class="no-data-labe">
            <h3 class="title">{{ "saveIplexDeviceImagesComponent.noFiles" | translate }}</h3>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<div class="action-area" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
  <mat-slide-toggle class="cut-toggle" [(ngModel)]="isDeletedWithUploading" [disabled]="imageFiles.length === 0 || isUnSelectedImageAll()">
    {{ (isDeletedWithUploading ? "saveIplexDeviceImagesComponent.cutReceiveImage" : "saveIplexDeviceImagesComponent.copyReceiveImage") | translate }}
  </mat-slide-toggle>
  <div class="file-details">
    <span class="details-label">{{ "saveIplexDeviceImagesComponent.images" | translate }}: {{ selectedImageCount }}</span>
    <span class="details-label">{{ "saveIplexDeviceImagesComponent.videos" | translate }}: {{ selectedVideoCount }}</span>
    <span class="details-label">{{ "saveIplexDeviceImagesComponent.totalFileSize" | translate }}: {{ selectedTotalFileSize | fileSize }}</span>
  </div>
</div>
<div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="5px">
  <button mat-button color="primary" [mat-dialog-close]="true">
    {{ "saveIplexDeviceImagesComponent.cancel" | translate }}
  </button>
  <button
    class="receive-btn"
    [disabled]="imageFiles.length === 0 || isUnSelectedImageAll()"
    mat-raised-button
    color="primary"
    (click)="receiveFiles()"
  >
    {{ "saveIplexDeviceImagesComponent.receive" | translate }}
  </button>
</div>
